import {
  REQUEST_WEB_CITIES, RECEIVE_WEB_CITIES, RECEIVE_WEB_CITY, COMPLETE_WEB_CITIES,
} from '../actions/web-cities';

const reducer = (state = { items: [], loading: false, item: {} }, action) => {
  switch (action.type) {
    case REQUEST_WEB_CITIES:
      return { ...state, loading: true };
    case RECEIVE_WEB_CITIES:
      return { ...state, items: action.items, loading: false };
    case RECEIVE_WEB_CITY:
      return { ...state, item: action.item, loading: false };
    case COMPLETE_WEB_CITIES:
      return { ...state, loading: false };
    default:
      return state;
  }
};

export default reducer;
